import { InjectionToken, Injector, Provider, Signal, Type } from '@angular/core';

/** One block of the plan panel, registered by the feature that owns it. */
export interface PlanPanelSection {
  /** Stable: the saved collapsed state is keyed by it. */
  id: string;
  titleKey: string;
  /** An `ICONS` entry. */
  icon: string;
  order: number;
  /** Reads the plan in view itself; the panel passes it no inputs. */
  component: Type<unknown>;
  /** Called once when the panel is created; the section is shown while the signal is true. */
  visible?: (injector: Injector) => Signal<boolean>;
  /** Rendered in the section's header beside its collapse toggle, shown even while collapsed. */
  headerActions?: Type<unknown>;
  /**
   * Column the section takes when the panel is expanded; left when unset. A right-column section
   * must have a higher `order` than every left-column one: collapsed, the right column stacks
   * below the left. The panel reports a violation in dev mode.
   */
  expandedColumn?: 'left' | 'right';
}

export const PLAN_PANEL_SECTIONS = new InjectionToken<PlanPanelSection[]>(
  'PLAN_PANEL_SECTIONS'
);

export function providePlanPanelSection(section: PlanPanelSection): Provider {
  return { provide: PLAN_PANEL_SECTIONS, multi: true, useValue: section };
}
